import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axios";
import { tenantFeatureEndpoint } from "@/config/endpoints";
import { useCallback } from "react";

interface TenantFeature {
  id: number;
  tenantId: number;
  key: string;
  isEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

export default function useTenantFeatures() {
  const query = useQuery<TenantFeature[]>({
    queryKey: ["tenant-features"],
    queryFn: async () => {
      const res = await axiosInstance.get(tenantFeatureEndpoint);
      return res.data.features;
    },
    staleTime: 1000 * 60 * 5,
  });

  const hasFeature = useCallback(
    (key: string): boolean => {
      if (!query.data) return false;
      const feature = query.data.find((f) => f.key === key);
      return feature?.isEnabled ?? false;
    },
    [query.data],
  );

  return {
    features: query.data ?? [],
    hasFeature,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
